export default __webpack_public_path__ + "static/media/leb-logo-150.0aa10d0b.png";